export default "__VITE_ASSET__arwyiX$x__"